import { Reveal, MaskedLine } from "@/components/Reveal";

const INCLUDED = [
  { n: "01", title: "SHUTUP T-SHIRT", desc: "Oversized T-shirt." },
  { n: "02", title: "SHUTUP BOX", desc: "Packed in a dedicated SHUTUP box." },
  { n: "03", title: "SHUTUP POSTER", desc: "A limited poster included with your order." },
];

export default function Packaging() {
  return (
    <section data-testid="packaging-section" className="bg-ink text-paper py-24 sm:py-36 overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-10">
        <Reveal>
          <p className="font-sans text-turq text-xs font-semibold tracking-[0.35em] mb-8">06 — THE PACKAGING</p>
        </Reveal>
        <h2 className="font-display leading-[0.9]">
          <MaskedLine inView className="text-[clamp(2.6rem,8vw,7rem)]">
            YOUR SHUTUP
          </MaskedLine>
          <MaskedLine inView delay={0.1} className="text-[clamp(2.6rem,8vw,7rem)]">
            COMES IN A <span className="text-acid">BOX.</span>
          </MaskedLine>
        </h2>

        <div className="grid lg:grid-cols-2 gap-12 mt-16 items-center">
          <div>
            <p className="font-sans text-paper/60 text-sm tracking-[0.25em] mb-6">EVERY ORDER INCLUDES:</p>
            <div className="border-t border-white/15">
              {INCLUDED.map((item, i) => (
                <Reveal key={item.n} delay={i * 0.08}>
                  <div className="flex items-baseline gap-6 py-6 border-b border-white/15 group" data-testid={`packaging-item-${item.n}`}>
                    <span className="font-display text-pink text-xl sm:text-2xl w-12 shrink-0">{item.n}</span>
                    <div>
                      <p className="font-sans font-bold text-lg sm:text-xl tracking-[0.1em] group-hover:text-turq transition-colors">
                        {item.title}
                      </p>
                      <p className="font-sans text-paper/55 text-sm mt-1">{item.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <Reveal delay={0.15}>
            <div className="grid grid-cols-2 gap-4 sm:gap-6 max-w-2xl mx-auto">
              <figure className="relative -rotate-2 hover:rotate-0 transition-transform duration-700" data-cursor="look">
                <img
                  src="/images/poster-talkies-1.webp"
                  alt="SHUTUP TALKIES limited poster — Leopard Eats Dialogue"
                  data-testid="packaging-poster"
                  className="w-full border-2 border-paper/20"
                />
              </figure>
              <figure className="relative rotate-2 hover:rotate-0 transition-transform duration-700 mt-8" data-cursor="look">
                <img
                  src="/images/poster-talkies-2.webp"
                  alt="SHUTUP TALKIES limited poster — Truth Is Drunk"
                  data-testid="packaging-poster-2"
                  className="w-full border-2 border-paper/20"
                />
              </figure>
              <figcaption className="col-span-2 font-hand text-acid text-2xl text-center -rotate-1 mt-2">
                the limited posters ↑ one in every box
              </figcaption>
            </div>
          </Reveal>
        </div>

        <div className="mt-28 sm:mt-36 text-center">
          <MaskedLine inView className="font-display text-pink text-[clamp(5rem,22vw,20rem)] leading-[0.85]" >
            ONLY 200.
          </MaskedLine>
          <Reveal delay={0.2}>
            <p className="font-sans text-paper/60 text-xs sm:text-sm tracking-[0.3em] mt-6">
              ONCE THEY'RE GONE, THIS EDITION IS GONE.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
